<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <v-footer class="border-t border-slate-200 bg-white">
    <v-container class="max-w-7xl py-8">
      <div class="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
        <div class="max-w-2xl">
          <div class="text-lg font-semibold text-slate-900">
            unilib
          </div>
          <div class="mt-2 text-sm leading-6 text-slate-600">
            {{ t('footer.description') }}
          </div>
        </div>

        <div class="text-sm text-slate-500">
          © 2026 unilib. {{ t('footer.rights') }}
        </div>
      </div>
    </v-container>
  </v-footer>
</template>
